import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useSingleSaleTableStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            flexDirection: 'column',
            paddingTop: 24,
            paddingBottom: 24,

            [theme.breakpoints.up('md')]: {
                paddingTop: '45px',
                paddingBottom: '45px'
            }
        },
        boxTitle: {
            paddingBottom: 16,

            [theme.breakpoints.up('md')]: {
                paddingBottom: '45px'
            }
        },
        title: {
            fontSize: 20,
            lineHeight: 1,
            fontWeight: 600,
            marginBottom: 8
        },
        subtitle: {
            fontSize: 14,
            lineHeight: 1.4,

            [theme.breakpoints.up('md')]: {
                fontSize: 16
            }
        },
        boxBottom: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between'
        },
        boxButton: {
            [theme.breakpoints.down('sm')]: {
                flex: '0 0 100%'
            }
        },
        addLineButton: {
            '& button': {
                [theme.breakpoints.down('sm')]: {
                    'height': 47,
                    'padding': '0px 22px',

                    '& .MuiButton-endIcon': {
                        'marginLeft': 8,
                        'marginRight': 0,

                        '& svg': {
                            width: 14,
                            height: 14
                        }
                    }
                }
            }
        },
        boxPayment: {
            display: 'flex',
            justifyContent: 'flex-end',
            flexDirection: 'column',
            paddingTop: 12,

            [theme.breakpoints.down('sm')]: {
                width: '100%'
            },
            [theme.breakpoints.up('md')]: {
                paddingTop: 128
            }
        },

        payButton: {
            [theme.breakpoints.down('sm')]: {
                'height': 55,
                'marginTop': 8,
                'borderRadius': 30,

                '& span': {
                    fontSize: 18,
                    fontWeight: 600
                }
            },
            [theme.breakpoints.up('md')]: {
                marginTop: '30px'
            }
        }
    })
);
